import { getProductCategory } from './allProducts'

let _boardGameCtx, _dsFrontCtx, _dsContentCtx, _dsBackCtx, _dsDescCtx
let _ldFrontCtx, _ldContentCtx, _ldBackCtx, _ldDescCtx
let _skFrontCtx, _skContentCtx, _skBackCtx, _skDescCtx
let _apFrontCtx, _apContentCtx, _apBackCtx, _apDescCtx
let _ggFrontCtx, _ggContentCtx, _ggBackCtx, _ggDescCtx
let _diceFrontCtx, _diceContentCtx, _diceBackCtx, _diceDescCtx

try { _boardGameCtx = { content: require.context('../Assets/board_games', true, /\/content\.(webp|png|jpg)$/i), back: require.context('../Assets/board_games', true, /\/back\.(webp|png|jpg)$/i), description: require.context('../Assets/board_games', true, /\/description\.txt$/i) } } catch {}

try { _dsFrontCtx = require.context('../Assets/tcg_accessories/dragon_shield', true, /\/front\.(webp|png|jpg)$/i) } catch {}
try { _dsContentCtx = require.context('../Assets/tcg_accessories/dragon_shield', true, /\/content\.(webp|png|jpg)$/i) } catch {}
try { _dsBackCtx = require.context('../Assets/tcg_accessories/dragon_shield', true, /\/back\.(webp|png|jpg)$/i) } catch {}
try { _dsDescCtx = require.context('../Assets/tcg_accessories/dragon_shield', true, /\/description\.txt$/i) } catch {}

try { _ldFrontCtx = require.context('../Assets/tcg_accessories/luck_dragon', true, /\/front\.(webp|png|jpg)$/i) } catch {}
try { _ldContentCtx = require.context('../Assets/tcg_accessories/luck_dragon', true, /\/content\.(webp|png|jpg)$/i) } catch {}
try { _ldBackCtx = require.context('../Assets/tcg_accessories/luck_dragon', true, /\/back\.(webp|png|jpg)$/i) } catch {}
try { _ldDescCtx = require.context('../Assets/tcg_accessories/luck_dragon', true, /\/description\.txt$/i) } catch {}

try { _skFrontCtx = require.context('../Assets/tcg_accessories/sleeve_kings', true, /\/front\.(webp|png|jpg)$/i) } catch {}
try { _skContentCtx = require.context('../Assets/tcg_accessories/sleeve_kings', true, /\/content\.(webp|png|jpg)$/i) } catch {}
try { _skBackCtx = require.context('../Assets/tcg_accessories/sleeve_kings', true, /\/back\.(webp|png|jpg)$/i) } catch {}
try { _skDescCtx = require.context('../Assets/tcg_accessories/sleeve_kings', true, /\/description\.txt$/i) } catch {}

try { _apFrontCtx = require.context('../Assets/tcg_accessories/army_painter', true, /\/front\.(webp|png|jpg)$/i) } catch {}
try { _apContentCtx = require.context('../Assets/tcg_accessories/army_painter', true, /\/content\.(webp|png|jpg)$/i) } catch {}
try { _apBackCtx = require.context('../Assets/tcg_accessories/army_painter', true, /\/back\.(webp|png|jpg)$/i) } catch {}
try { _apDescCtx = require.context('../Assets/tcg_accessories/army_painter', true, /\/description\.txt$/i) } catch {}

try { _ggFrontCtx = require.context('../Assets/tcg_accessories/graded_guard', true, /\/front\.(webp|png|jpg)$/i) } catch {}
try { _ggContentCtx = require.context('../Assets/tcg_accessories/graded_guard', true, /\/content\.(webp|png|jpg)$/i) } catch {}
try { _ggBackCtx = require.context('../Assets/tcg_accessories/graded_guard', true, /\/back\.(webp|png|jpg)$/i) } catch {}
try { _ggDescCtx = require.context('../Assets/tcg_accessories/graded_guard', true, /\/description\.txt$/i) } catch {}

try { _diceFrontCtx = require.context('../Assets/tcg_accessories/dice', true, /\/front\.(webp|png|jpg)$/i) } catch {}
try { _diceContentCtx = require.context('../Assets/tcg_accessories/dice', true, /\/content\.(webp|png|jpg)$/i) } catch {}
try { _diceBackCtx = require.context('../Assets/tcg_accessories/dice', true, /\/back\.(webp|png|jpg)$/i) } catch {}
try { _diceDescCtx = require.context('../Assets/tcg_accessories/dice', true, /\/description\.txt$/i) } catch {}

const categoryAssets = {
  boardGame: _boardGameCtx || null,
  dragonShield: { front: _dsFrontCtx, content: _dsContentCtx, back: _dsBackCtx, description: _dsDescCtx },
  luckDragon: { front: _ldFrontCtx, content: _ldContentCtx, back: _ldBackCtx, description: _ldDescCtx },
  sleeveKings: { front: _skFrontCtx, content: _skContentCtx, back: _skBackCtx, description: _skDescCtx },
  armyPainter: { front: _apFrontCtx, content: _apContentCtx, back: _apBackCtx, description: _apDescCtx },
  gradedGuard: { front: _ggFrontCtx, content: _ggContentCtx, back: _ggBackCtx, description: _ggDescCtx },
  dice: { front: _diceFrontCtx, content: _diceContentCtx, back: _diceBackCtx, description: _diceDescCtx },
}

export const getAssetsForCategory = (category) => categoryAssets[category] || null

const _resolveAssetPath = (loader, productId, ext) => {
  if (!loader) return null
  try {
    const p = `./${productId}${ext}`
    if (loader.keys().includes(p)) return loader(p)
  } catch (_) {}
  return null
}

export const getProductImages = (product) => {
  if (!product) return []
  const category = getProductCategory(product.id)
  const assets = getAssetsForCategory(category)
  const ext = product.imageExt || '.webp'
  const list = []

  if (product.image) {
    list.push({ src: product.image, alt: product.name, label: 'Front' })
  }

  if (assets) {
    const contentSrc = _resolveAssetPath(assets.content, product.id, ext)
    if (contentSrc) {
      list.push({ src: contentSrc, alt: `${product.name} content`, label: 'Content' })
    }
    const backSrc = _resolveAssetPath(assets.back, product.id, ext)
    if (backSrc) {
      list.push({ src: backSrc, alt: `${product.name} back`, label: 'Back' })
    }
  }

  return list
}

const _tryFetchDescription = (url) =>
  fetch(url).then((r) => r.text()).catch(() => '')

export const loadProductDescription = (product) => {
  if (!product) return Promise.resolve('')
  if (product.longDescription) return Promise.resolve(product.longDescription)
  if (product.description) return Promise.resolve(product.description)

  const category = getProductCategory(product.id)
  const assets = getAssetsForCategory(category)
  if (!assets) return Promise.resolve('')

  try {
    const p = `./${product.id}/description.txt`
    if (assets.description.keys().includes(p)) {
      return _tryFetchDescription(assets.description(p))
    }
  } catch (_) {}

  return Promise.resolve('')
}
